var scope_0 = require('/opt/build/repo/node_modules/mdx-deck/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/aad1a641f51c66c6ece46ba8ed4a57fd.js').default;export default
        Object.assign({}, scope_0 )
    